import axios from 'axios'
import qs from 'qs'
import store from '../store'
import { setSign } from '@/MD5'

//基础URL 线上环境
const baseUrl = 'https://www.shoudaole.cn/api/';
// const baseUrl = 'http://pc.sdl.com/api/';

//基础URL 测试服务器环境
axios.defaults.baseURL = baseUrl;

// 设置超时时间
axios.defaults.timeout = 60000;

// 全局设置头部信息
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求路由拦截
axios.interceptors.request.use(config => {
    let sign = null;
    if(config.method === 'get'){
        if(config.params){
            let temp = '',
                data = config.params;
            for (let prop in data){
                temp += prop + '=' + data[prop] + '&';
            }
            const param = temp.slice(0,temp.length - 1);
            sign = setSign(param);
            config.params = {
                ...config.params,
                sign,
            }
        }
    }else if(config.method === 'post'){
        if(typeof config.data === 'string'){
            sign = setSign(config.data);
            config.data += '&sign=' + sign;
        }
    }
    return config;
}, error => {
    // 请求错误
    return Promise.reject(error);
});


// 响应拦截
axios.interceptors.response.use(response => {
    // 处理响应数据
    if (response.status === 200) {
        return Promise.resolve(response.data);
    } else {
        return Promise.reject(response.data);
    }
}, error => {//响应失败
    if (error.response) {
        switch (error.response.status) {
            case 401:
                // 返回 401 清除token信息并跳转到登录页面
                store.commit(types.LOGOUT);
                router.replace({
                    path: 'login',
                    query: { redirect: router.currentRoute.fullPath }
                })
        }
    }
    return Promise.reject(error);
});

// GET请求
export const GET = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params })
            .then(res => {
                resolve(res);
            }).catch(err => {
            reject(err);
        })
    })
};

// POST请求
export const POST = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(params))
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
};

export const baseURL = baseUrl;